import { ability } from '@/app/shared/services/ability-service';
import type {
  Actions,
  AppSubjects,
  AMSSubjects,
  AdminSubjects,
  ToolsSubject,
  ViewerSubjects,
} from '@/app/shared/services/ability-service';

type Subjects =
  | AppSubjects
  | AMSSubjects
  | AdminSubjects
  | ToolsSubject
  | ViewerSubjects;

export class AccessGuard {
  static can(action: Actions, subject: Subjects): boolean {
    return ability.can(action, subject);
  }

  static cannot(action: Actions, subject: Subjects): boolean {
    return ability.cannot(action, subject);
  }

  static canWrite(subject: Subjects): boolean {
    return this.can('WRITE', subject);
  }

  static canModify(subject: Subjects): boolean {
    return this.canWrite(subject) || this.isAdmin();
  }

  static canRead(subject: Subjects): boolean {
    return this.can('READ', subject);
  }

  static cannotWrite(subject: Subjects): boolean {
    return this.cannot('WRITE', subject);
  }

  static hasNoAccess(subject: Subjects): boolean {
    return this.cannot('READ', subject) && this.cannot('WRITE', subject);
  }

  static hasAccess(subject: Subjects): boolean {
    return !this.hasNoAccess(subject) || this.isAdmin();
  }

  static isAdmin(): boolean {
    return this.can('WRITE', 'ALL');
  }
}

export default AccessGuard;
